module.exports = {
    production : true,
    version: 0.8,
    googleMapApiKey: 'AIzaSyAaNHmP8EJT-nE4XNlV0HRZv35S_5cOklU',
    newsApiKey: '7f5db4f5b7754d2897f5a4fc507929bc'
};
